import { getSearchParam } from "@swa-ui/browser";
import { personas, siteToPersona } from "@swa-ui/personas/defines";

import { channelMapping } from "../defines";

export const getChannelId = (persona) => {
  const channelParam = getSearchParam("channel");
  const site = process.env.SITE;
  const personaToMap = persona ?? siteToPersona[process.env.SITE] ?? personas.leisure;
  const channel = channelMapping[site] ?? channelMapping.southwest;

  return channelParam ? channelParam.toLowerCase() : channel[personaToMap];
};
